<!-- begin::Header -->
<header class="n-head-wrap" data-minimize="minimize" data-minimize-offset="200" data-minimize-mobile-offset="200"
	appunwraptag="">
	<div class="n-top-head d-flex align-items-center justify-content-between">
		<div class="s-logo-l-block d-flex">
			<div class="l-link">
				<a href="#" class="text-end">
					भारत सरकार
				</a>
				<a href="#" class="text-end">GOVERNMENT OF INDIA</a>
			</div>
			<div class="l-link">
				<a href="#">
					सूक्ष्म , लघु और मध्यम उद्यम मंत्रालय
				</a>
				<a href="#">
					MINISTRY OF MICRO, SMALL & MEDIUM ENTERPRISES
				</a>
			</div>
		</div>

		<div class="l-link d-flex">
			<a routerLink="/languages" style="margin-left: 670px; color: white; font-size: 12px">
				<p style="margin-top: 1px">Resources</p>
			</a>
		</div>

		<div class="s-lan-right-block">
			<ul class="d-flex">
				<li>
					<a href="https://twitter.com/minmsme" aria-label="Link to twitter" target="_blank">
						<svg width="21" height="16" viewBox="0 0 300 300" version="1.1"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66"
								fill="white" stroke="white" />
						</svg>
					</a>
				</li>
				<li>
					<a href="https://www.youtube.com/@@ministryofmicrosmallmedium5343" aria-label="Link to youtube"
						target="_blank">
						<svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M11.6667 10.2174L8.75 11.8841V8.55078L11.6667 10.2174Z" fill="white" stroke="white"
								stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M1.66675 10.8066V9.62748C1.66675 7.21498 1.66675 6.00831 2.42091 5.23248C3.17591 4.45581 4.36425 4.42248 6.74008 4.35498C7.86508 4.32331 9.01508 4.30081 10.0001 4.30081C10.9842 4.30081 12.1342 4.32331 13.2601 4.35498C15.6359 4.42248 16.8242 4.45581 17.5784 5.23248C18.3334 6.00831 18.3334 7.21581 18.3334 9.62748V10.8066C18.3334 13.22 18.3334 14.4258 17.5792 15.2025C16.8242 15.9783 15.6367 16.0125 13.2601 16.0791C12.1351 16.1116 10.9851 16.1341 10.0001 16.1341C8.91321 16.1309 7.82644 16.1125 6.74008 16.0791C4.36425 16.0125 3.17591 15.9791 2.42091 15.2025C1.66675 14.4258 1.66675 13.2191 1.66675 10.8075V10.8066Z"
								stroke="white" stroke-width="1.25" />
							<path
								d="M4.61002 4.55662C6.9196 4.44162 8.71585 4.38412 9.99919 4.38412C11.2825 4.38412 13.0796 4.44162 15.3904 4.55704C15.9951 4.58722 16.5683 4.83582 17.0036 5.25667C17.4388 5.67753 17.7066 6.24204 17.7571 6.84537C17.8629 8.10954 17.9159 9.22287 17.9159 10.1858C17.9159 11.1604 17.8617 12.2891 17.7534 13.5725C17.7031 14.1689 17.4405 14.7274 17.0133 15.1467C16.5861 15.5659 16.0227 15.818 15.4254 15.857C13.45 15.9862 11.6413 16.0508 9.99919 16.0508C8.35752 16.0508 6.54919 15.9862 4.57502 15.857C3.97796 15.818 3.41471 15.5661 2.98756 15.1471C2.56041 14.7282 2.29768 14.1699 2.2471 13.5737C2.13752 12.2808 2.08252 11.1512 2.08252 10.1858C2.08252 9.23162 2.13627 8.11787 2.24294 6.84412C2.29364 6.24094 2.56146 5.67663 2.99671 5.25594C3.43195 4.83526 4.00504 4.58678 4.6096 4.55662H4.61002Z"
								stroke="white" stroke-width="1.66667" stroke-linejoin="round" />
							<path
								d="M8.75 8.38832V12.0533C8.74997 12.1179 8.76744 12.1812 8.80055 12.2366C8.83365 12.292 8.88115 12.3374 8.938 12.368C8.99485 12.3985 9.05892 12.4131 9.1234 12.4102C9.18787 12.4072 9.25034 12.3869 9.30417 12.3512L12.0529 10.5346C12.102 10.5022 12.1424 10.4582 12.1704 10.4064C12.1984 10.3547 12.2132 10.2968 12.2134 10.2379C12.2137 10.1791 12.1994 10.1211 12.1718 10.0691C12.1443 10.0171 12.1043 9.97278 12.0554 9.93998L9.30625 8.09165C9.25252 8.05554 9.18999 8.03472 9.12534 8.03141C9.06069 8.0281 8.99636 8.04243 8.93923 8.07286C8.88209 8.10329 8.8343 8.14867 8.80097 8.20417C8.76764 8.25966 8.75002 8.32317 8.75 8.3879V8.38832Z"
								stroke="white" stroke-width="1.42875" stroke-linejoin="round" />
						</svg>
					</a>
				</li>
				<li>
					<a href="https://www.facebook.com/minmsme?mibextid=LQQJ4d" aria-label="Link to facebook"
						target="_blank">
						<svg width="18" height="20" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path opacity="1" fill-rule="evenodd" clip-rule="evenodd"
								d="M18 0.708333V16.2917C18 16.5732 17.5549 16.9936 17.25 17H12.75V10.625H15V7.79167H12.75V6.375C12.4226 5.46497 12.6384 4.96178 13.5 4.95833H15V2.83333C14.9584 2.63694 14.1087 2.56688 12.75 2.83333C11.0333 2.56688 9.61709 3.76433 9.75 5.66667V7.79167H7.5V10.625H9.75V17H0.75C0.445111 17 0 16.5796 0 16.2917V0.708333C0 0.420382 0.445111 0 0.75 0H17.25C17.5549 0 18 0.414013 18 0.708333Z"
								fill="white"></path>
						</svg>
					</a>
				</li>
				<li>
					<button type="button" class="lang-drop dropdown-toggle" data-bs-toggle="dropdown"
						aria-expanded="false">
						Language
					</button>
					<ul class="dropdown-menu dropdown-menu-end">
						<li><button class="dropdown-item" type="button">हिन्दी</button></li>
						<li><button class="dropdown-item" type="button">English</button></li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
	<div class="m-nav">
		<div class="l-m-logo">
			<div class="l-img">
				<img src="assets/images/vs/n/emblem-dark.png" alt="" title="" />
			</div>
			<div class="l-con">
				<h2>
					सूक्ष्म , लघु और मध्यम उद्यम मंत्रालय
				</h2>

				<span>
					Ministry of
				</span>
				<h1 style="font-weight:800">
					Micro, small & Medium Enterprises
				</h1>
			</div>
		</div>
		<div class="m-right-logo">
			<div class="g2-logo">
				<img src="assets/images/vs/n/PM-Vishwakarma-Logo-FINAL1.png" alt="" title="" />
			</div>
			<div class="g2-logo">
				<img src="assets/images/vs/n/g20.svg" alt="" title="" />
			</div>
			<div class="g2-logo">
				<img src="assets/images/vs/n/azadi23.svg" alt="" title="" />
			</div>
			<!-- <div class="az-logo">
				<img src="assets/images/vs/partners/logo4.png" alt="" title="" />
			</div> -->
			<div class="az-logo">
				<div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
					<div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general">
						<div class="m-stack__item m-topbar__nav-wrapper">
							<ul class="m-topbar__nav m-nav m-nav--inline">
								<li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
									data-dropdown-toggle="click" *ngIf="userInfo">
									<a href="javascript:;" class="m-nav__link m-dropdown__toggle">
										<span class="m-topbar__userpic">
											<img [src]="userData.imageUrl"
												class="m--img-rounded m--marginless m--img-centered" alt="" />
											<!-- <img src="../../../assets/images/Dummy_Image_Man.jpg" class="m--img-rounded m--marginless m--img-centered" alt="" /> -->
											<span class="m-topbar__welcome user-name">
												{{userInfo.userName}}
											</span>
										</span>
									</a>
									<div class="m-dropdown__wrapper" *ngIf="userInfo">
										<span
											class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
										<div class="m-dropdown__inner">
											<div class="m-dropdown__header m--align-center">
												<div class="m-card-user m-card-user--skin-dark">
													<div class="m-card-user__pic">
														<img [src]="userData.imageUrl"
															class="m--img-rounded m--marginless" alt="" />
													</div>
													<div class="m-card-user__details">
														<span class="m-card-user__name m--font-weight-500">
															{{userInfo.userName}}
														</span>
														<span class="m-card-user__email m--font-weight-300 m-link">
															{{userInfo.role === 'Training Partner' ?
															userInfo?.generalDetailsOfTP?.nameOfTheOrganisation :
															userInfo.role === 'Training Centre' ? 
															userInfo?.trainingCentreName : 
															userInfo?.firstName ? userInfo?.firstName : ''}}
														</span>
														<a class="m-card-user__email m--font-weight-300 m-link">
															{{userInfo.email}}
														</a>
													</div>
												</div>
											</div>
											<div class="m-dropdown__body">
												<div class="m-dropdown__content">
													<ul class="m-nav m-nav--skin-light">
														<li class="m-nav__item" *ngFor="let userConfig of userSetting">
															<a [routerLink]="userConfig.redirectLink"
																class="m-nav__link">
																<i class="m-nav__link-icon flaticon-profile-1"></i>
																<span class="m-nav__link-title">
																	<span class="m-nav__link-wrap">
																		<span class="m-nav__link-text">
																			{{userConfig.name}}
																		</span>
																	</span>
																</span>
															</a>
														</li>
														<li class="m-nav__item" *ngIf="userInfo.type === 'ADMIN' ">
															<a [routerLink]="['./edit-profile', userInfo.userName]"
																class="m-nav__link">
																<i class="m-nav__link-icon fa fa-user"></i>
																<span class="m-nav__link-text">
																	My profile
																</span>
															</a>
														</li>
														<li class="m-nav__separator m-nav__separator--fit"></li>
														<li class="m-nav__item">
															<button
																class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder"
																(click)="logout()">
																Logout
															</button>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="m-header__bottom white-bar">
		<div class="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
			<div class="m-stack m-stack--ver m-stack--desktop">
				<!-- begin::Horizontal Menu -->
				<div class="m-stack__item m-stack__item--middle m-stack__item--fluid">
					<button class="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-light"
						id="m_aside_header_menu_mobile_close_btn">
						<i class="la la-close"></i>
					</button>
					<div id="m_header_menu"
						class="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-light m-aside-header-menu-mobile--submenu-skin-light">
						<ul class="m-menu__nav  m-menu__nav--submenu-arrow">
							<li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
								routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{ exact: true }"
								*ngFor="let element of navElements; let i=index" data-menu-submenu-toggle="click"
								aria-haspopup="true">
								<a href="javascript:;" class="m-menu__link m-menu__toggle"
									(click)="navigateTo(element.route)">
									<span class="m-menu__item-here"></span>
									<span class="m-menu__link-text">
										<img *ngIf="element.icon !== undefined" [class]="element.icon"
											[src]="element.icon" alt=""> {{element.element}}
									</span>
									<i *ngIf="element.subelements !== 'undefined' && element?.subelements?.length > 0"
										class="m-menu__hor-arrow la la-angle-down"></i>
									<i *ngIf="element.subelements !== 'undefined' && element?.subelements?.length > 0"
										class="m-menu__ver-arrow la la-angle-right"></i>
									<i *ngIf="element.element === 'Dashboard' && element.subelements !== 'undefined' && element?.subelements?.length === 0 && (userInfo && userInfo.role == 'SSC' ||  userInfo.type == 'awardingBody')"
										class="m-menu__hor-arrow la la-angle-down"></i>
								</a>
								<ng-container *ngIf="element.subMenus &&( userInfo.role === 'SSC' || userInfo.role == 'SSDM PMU RPL')">
									<div *ngIf="element.subMenus !== 'undefined' && element?.subMenus?.length > 0"
										class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
										<span class="m-menu__arrow m-menu__arrow--adjust suarrow"></span>
										<ul style="list-style-type:disc;" class="m-menu__subnav">
											<li *ngFor="let subelement  of element.subMenus" class="m-menu__item"
												routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
												<a href="javascript:;" class="m-menu__link create"
													(click)="navigateTo(subelement.route)">
													<span class="m-menu__link-text">
														{{subelement.elementName}}
													</span>
												</a>
											</li>
										</ul>
									</div>
								</ng-container>
								<ng-container *ngIf="userInfo.role === 'Training Centre'">
									<div *ngIf="element.subelements !== 'undefined' && element?.subelements?.length > 0"
										class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left ">
										<span class="m-menu__arrow m-menu__arrow--adjust"></span>
										<ul class="m-menu__subnav">
											<li *ngFor="let subelement  of element.subelements"
												class="m-menu__item  m-menu__item--submenu m-menu__item--rel hover_1"
												routerLinkActive="m-menu__item--open"
												routerLinkActiveOptions="{ exact: true }"
												data-menu-submenu-toggle="hover" aria-haspopup="true">
												<a href="javascript:;" class="m-menu__link m-menu__toggle"
													(click)="navigateToRouteWithQuery(subelement.value)">
													<span class="m-menu__link-text">
														{{subelement.createBatch}}
													</span>
												</a>
											</li>
										</ul>
									</div>
								</ng-container>
								<ng-container *ngIf="userInfo.role === 'Training Partner'">
									<div *ngIf="element.subelements !== 'undefined' && element?.subelements?.length > 0"
										class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left ">
										<span class="m-menu__arrow m-menu__arrow--adjust"></span>
										<ul class="m-menu__subnav">
											<li *ngFor="let subelement  of element.subelements"
												class="m-menu__item  m-menu__item--submenu m-menu__item--rel  hover_1"
												routerLinkActive="m-menu__item--open"
												routerLinkActiveOptions="{ exact: true }"
												data-menu-submenu-toggle="hover" aria-haspopup="true">
												<a href="javascript:;" class="m-menu__link m-menu__toggle"
													(click)="navigateToTrainingPartner(subelement.value)">
													<span class="m-menu__link-text">
														{{subelement.createScheme}}
													</span>
												</a>
											</li>
										</ul>
									</div>
								</ng-container>
								<!-- qpnos-navigation -->
								<div *ngIf="element.subelements !== 'undefined' && element?.subelements?.length > 0 && userInfo.role !== 'Training Centre' && userInfo.role !== 'Training Partner'"
									class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left ">
									<span class="m-menu__arrow m-menu__arrow--adjust"></span>
									<ul class="m-menu__subnav">
										<li *ngFor="let subelement  of element.subelements"
											class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
											routerLinkActive="m-menu__item--open"
											routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="hover"
											aria-haspopup="true">
											<a href="javascript:;" class="m-menu__link m-menu__toggle">
												<span class="m-menu__link-text">
													{{subelement.nosocst}}
												</span>
												<i *ngIf="subelement.nosocst !== 'undefined' && subelement?.nosocst?.length > 0"
													class="m-menu__ver-arrow la la-angle-right angle-right"></i>
											</a>
											<div *ngIf="subelement.nosocst !== 'undefined' && subelement?.nosocst?.length > 0"
												class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
												<span class="m-menu__arrow m-menu__arrow--adjust suarrow"></span>
												<ul style="list-style-type:disc;" class="m-menu__subnav">
													<li *ngFor="let drp of subelement.nosOcc" class="m-menu__item"
														routerLinkActive="active"
														[routerLinkActiveOptions]="{exact: true}">
														<a href="javascript:;" class="m-menu__link create"
															(click)="navigateTo(drp.route)">
															<span class="m-menu__link-text">
																{{drp.createnos}}
															</span>
														</a>
														<a href="javascript:;" class="m-menu__link create"
															(click)="navigateTo(drp.route)">
															<span class="m-menu__link-text">
																{{drp.viewAllNos}}
															</span>
														</a>
													</li>
												</ul>
											</div>
										</li>
										<li *ngFor="let subelement  of element.subelements"
											class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
											routerLinkActive="m-menu__item--open"
											routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="hover"
											aria-haspopup="true">
											<a href="javascript:;" class="m-menu__link m-menu__toggle">
												<span class="m-menu__link-text">
													{{subelement.qpPack}}
												</span>
												<i *ngIf="subelement.qpPack !== 'undefined' && subelement?.qpPack?.length > 0"
													class="m-menu__ver-arrow la la-angle-right angle-right"></i>
											</a>
											<div *ngIf="subelement.qpPack !== 'undefined' && subelement?.qpPack?.length > 0"
												class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
												<span class="m-menu__arrow m-menu__arrow--adjust suarrow"></span>
												<ul style="list-style-type:disc;" class="m-menu__subnav">
													<li *ngFor="let drp of subelement.qppack" class="m-menu__item"
														routerLinkActive="active"
														[routerLinkActiveOptions]="{exact: true}">
														<a href="javascript:;" class="m-menu__link create"
															(click)="navigateTo(drp.route)">
															<span class="m-menu__link-text">
																{{drp.createQp}}
															</span>
														</a>
														<a href="javascript:;" class="m-menu__link create"
															(click)="navigateTo(drp.route)">
															<span class="m-menu__link-text">
																{{drp.viewallqp}}
															</span>
														</a>
													</li>
												</ul>
											</div>
										</li>
										<li *ngFor="let subelement  of element.subelements"
											class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
											routerLinkActive="m-menu__item--open"
											routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="hover"
											aria-haspopup="true">
											<a href="javascript:;" class="m-menu__link m-menu__toggle">
												<span class="m-menu__link-text">
													{{subelement.mcPack}}
												</span>
												<i *ngIf="subelement.mcPack !== 'undefined' && subelement?.mcPack?.length > 0"
													class="m-menu__ver-arrow la la-angle-right angle-right"></i>
											</a>
											<div *ngIf="subelement.mcPack !== 'undefined' && subelement?.mcPack?.length > 0"
												class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
												<span class="m-menu__arrow m-menu__arrow--adjust suarrow"></span>
												<ul style="list-style-type:disc;" class="m-menu__subnav">
													<li *ngFor="let drp of subelement.mcpack" class="m-menu__item"
														routerLinkActive="active"
														[routerLinkActiveOptions]="{exact: true}">
														<a href="javascript:;" class="m-menu__link create"
															(click)="navigateTo(drp.route)">
															<span class="m-menu__link-text">
																{{drp.createMc}}
															</span>
														</a>
														<a href="javascript:;" class="m-menu__link create"
															(click)="navigateTo(drp.route)">
															<span class="m-menu__link-text">
																{{drp.viewallmc}}
															</span>
														</a>
													</li>
												</ul>
											</div>
										</li>
										<li *ngFor="let subelement  of element.subelements"
											class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
											routerLinkActive="m-menu__item--open"
											routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="hover"
											aria-haspopup="true">
											<a href="javascript:;" class="m-menu__link m-menu__toggle">
												<span class="m-menu__link-text">
													{{subelement.microPack}}
												</span>
												<i *ngIf="subelement.microPack !== 'undefined' && subelement?.microPack?.length > 0"
													class="m-menu__ver-arrow la la-angle-right angle-right"></i>
											</a>
											<div *ngIf="subelement.micropack !== 'undefined' && subelement?.micropack?.length > 0"
												class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
												<span class="m-menu__arrow m-menu__arrow--adjust suarrow"></span>
												<ul style="list-style-type:disc;" class="m-menu__subnav">
													<li *ngFor="let drp of subelement.micropack" class="m-menu__item"
														routerLinkActive="active"
														[routerLinkActiveOptions]="{exact: true}">
														<a href="javascript:;" class="m-menu__link create"
															(click)="navigateTo(drp.route)">
															<span class="m-menu__link-text">
																{{drp.createMicro}}
															</span>
														</a>
														<a href="javascript:;" class="m-menu__link create"
															(click)="navigateTo(drp.route)">
															<span class="m-menu__link-text">
																{{drp.viewAllMicro}}
															</span>
														</a>
													</li>
												</ul>
											</div>
										</li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>